

export const elaineBio = {
  _id: 'elaineBioId',
  userId: 'elaineUserId',
  email: 'elaine@email.com',
  aboutMe: [
    `Daytime publicist searching for her nighttime public-kiss`,
    `Your typical young romantic in search of this, that, and the other`,
    `Was in a 'contest' with three crazed men and somehow didn't win`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who looks good in a suit, bonus points if your last name is Kennedy`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Dancing, it's something I do naturally`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Is a muffin all about the muffin top?`,
    }
  ],
  hobbies: [
    `Fashion`,
    `Literature`,
    `Restaurants`,
    `Zabars`,
    `Melodrama`
  ],
  vitalInfo: {
    firstName: `Elaine`, 
    age: 31,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 65,
    heightCM: 166,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Baltimore`,
    languages: [`English`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Tufts University`,
    profession: `Editor`,
    employer: `Book Publishing`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const georgeBio = {
  _id: 'georgeBioId',
  userId: 'georgeUserId',
  email: 'george@email.com',
  aboutMe: [
    `I'm bald, unemployed, and I live with my parents`,
    `Self-loathing bald man but too proud to wear a toupé`,
    `Like a jingle, annoying at first but will get stuck in your head`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A jerk store`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Double-fisting hors-d'oeuvres`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `When you quit your job in a blind rage, do you come in the next day and pretend it was all a joke?`,
    }
  ],
  hobbies: [
    `Baseball`,
    `Scheming`,
    `Eating`,
    `Modeling`,
    `Melodrama`
  ],
  vitalInfo: {
    firstName: `George`, 
    age: 37,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 66,
    heightCM: 168,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Long Island`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Queens College`,
    profession: `Architect`,
    employer: `Architecture Firm`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const kramerBio = {
  _id: 'kramerBioId',
  userId: 'kramerUserId',
  email: 'kramer@email.com',
  aboutMe: [
    `Creator of the male brassiere, the coffee table book about coffee tables, and beach-scented cologne`,
    `Here's to feeling good all the time`,
    `I suck'em down like Coca Cola`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A Titlist`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Whacking golf balls into the ocean`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Can a shower drain double as a garbage disposal?`,
    }
  ],
  hobbies: [
    `Mooching`,
    `Entrepreneurship`,
    `Tinkering`,
    `Golf`,
    `Mayhem`
  ],
  vitalInfo: {
    firstName: `Kramer`, 
    age: 43,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 75,
    heightCM: 190,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `NYC`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: `Founder`,
    employer: `Kramerica Industries`,
    children: `Don't have children`,
    familyPlans: `Don't want children`,
    datingIntentions: `Short-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `Sometimes`,
    weed: `Sometimes`,
    drugs: `Sometimes`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const jerryBio = {
  _id: 'jerryBioId',
  userId: 'jerryUserId',
  email: 'jerry@email.com',
  aboutMe: [
    ``,
    ``,
    ``
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: ``,
    },
    {
      prompt: `My simple pleasures`,
      response: ``,
    },
    {
      prompt: `Let's debate this topic`,
      response: ``,
    }
  ],
  hobbies: [
    ``,
    ``,
    ``,
    ``,
    ``
  ],
  vitalInfo: {
    firstName: `Jerry`, 
    age: 37,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 73,
    heightCM: 182,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Long Island`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: ``,
    profession: `Comedian`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}